import { ReactElement, useState, useEffect } from 'react';
import { Component as Cart } from 'icons/icon-ui--cart-small.svg';
import { Component as CloseIcon } from 'icons/icon-ui--remove.svg';
import Button from 'react-bootstrap/Button';
import QuantityPicker from 'components/Cart/shared/QuantityPicker';
import Plan, { Extras } from 'models/Plan';
import useCurrentUser from 'hooks/useCurrentUser';
import { post } from '../../../utils/network';
import { ApiRoute } from '../../../config';

type AddOnsProps = {
    planData: Plan;
    plan: string;
    mealType: string;
    servingSize: string;
    pricePerServing?: string;
    imageKey: string;
    maxQuantity: number;
};

function AddOns({
  planData,
  plan,
  mealType,
  servingSize,
  pricePerServing,
  imageKey,
  maxQuantity,
}: AddOnsProps): ReactElement {
  const { currentUser, reload: reloadUser } = useCurrentUser();
  const currUserSubscription = currentUser.subscription;

  const mealKeyMap: Record<string, keyof Extras> = {
    Breakfast: 'breakfast',
    Lunch: 'lunch',
    Dinner: 'dinner',
  };
  const mealKey = mealKeyMap[mealType];
  const [quantity, setQuantity] = useState(currUserSubscription?.extras[mealKey] ?? 0);
  const [added, setAdded] = useState((currUserSubscription?.extras[mealKey] ?? 0) > 0);

  const handlePlanChange = async (newPlan: Plan) => {
    await post(`${ApiRoute.USERS}/me/subscription`, {
      subscription: {
        plan: newPlan.name,
        extra_meals: newPlan.selectedExtras,
      },
    });

    reloadUser();
  };

  const handleQuantityChange = async (qty: number) => {
    const updatedExtras: Extras = {
      ...planData.selectedExtras,
    };

    if (mealType === 'Breakfast') updatedExtras.breakfast = qty;
    else if (mealType === 'Lunch') updatedExtras.lunch = qty;
    else if (mealType === 'Dinner') updatedExtras.dinner = qty;

    const newPlan = new Plan(planData.name);
    newPlan.selectedExtras = { ...updatedExtras };
    setQuantity(qty);
    await handlePlanChange(newPlan);
  };

  const handleAddToCart = () => {
    setAdded(true);
    handleQuantityChange(1);
  };

  const handleRemoveFromCart = () => {
    setAdded(false);
    handleQuantityChange(0);
  };

  return (
    <div className="c-my-account__add-ons">
      <div className="c-my-account__add-ons__container">
        <div className={`c-my-account__add-ons__content--top c-my-account__add-ons__content--top--${imageKey}`} />
        <div className="c-my-account__add-ons__center">
          <p className="c-my-account__add-ons__plan">{plan}</p>
          <div className="c-my-account__add-ons__content--bottom">
            <p className="c-my-account__add-ons__meal_type">{mealType}</p>
          </div>
          <p className="c-my-account__add-ons__meal_desc">
            {servingSize}
            {' '}
            {servingSize === '1' ? 'serving' : 'servings'}
            {pricePerServing ? `, $${pricePerServing} / serving` : ''}
          </p>

          {!added ? (
            <div className="c-my-account__add-ons__button_with_icon">
              <Button
                type="button"
                className="c-my-account__add-ons__add_button c-button c-button--primary c-add-to-cart__default"
                onClick={handleAddToCart}
              >
                <Cart className="c-my-account__add-ons__cart_icon" />
                <span className="c-add-to-cart__default-text">Add</span>
              </Button>
            </div>
          ) : (
            <div className="c-my-account__add-ons__quantity_button_with_icon">
              <QuantityPicker
                quantity={
                    quantity || 0
                }
                minQuantity={1}
                maxQuantity={maxQuantity}
                onRecipePage={false}
                skuId={1}
                onChange={handleQuantityChange}
                heapEventTicker={undefined}
                heapEventTickerAmount={undefined}
                tooltipErrorMessage=""
              />
              <CloseIcon
                className="c-my-account__add-ons__close_icon"
                style={{ cursor: 'pointer', pointerEvents: 'all' }}
                onClick={handleRemoveFromCart}
              />

            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default AddOns;
